module.exports = __webpack_public_path__ + "static/media/280.fbf08e5d.png";